import React, { useState, useEffect } from 'react'
import Loader from '../../../../../presentationals/Loader/Loader.component'

import { getDocumentDetailApi } from '../CommunityActionCreator';
let fileData = []

const maxSize = 10 * 1024 * 1024;

export default function AddDocumentsNew({ communityId }) {
    const [loaderState, setLoaderState] = useState(false)
    const [apiData, setAPIData] = useState([])
    const [ViewDocument, setViewDocument] = useState({})
    const [documentPopup, setdocumentPopup] = useState(false)



    

    useEffect(() => {
        getDocumentDetailFunction()
    }, [])


    const getDocumentDetailFunction = () => {
        setLoaderState(true)
        getDocumentDetailApi(1, 10, communityId, (callback) => {
            setLoaderState(false)
            console.log(callback)
            setAPIData(callback)
        })
    }

    const handleViewDoc =(data)=>{
        console.log("data",data)
        setViewDocument(data)
        setTimeout(()=>{
            setdocumentPopup(true)
        },200)
    }


    const handlclose =()=>{
        setdocumentPopup(false)
        setViewDocument({})
    }

    return (
        <>
            <div className='container hoverNone card'>
                {loaderState ?
                    <Loader />
                    : null}


                <div>
                    <h4 style={{ fontSize: '20px' }}>Uploaded Documents</h4>
                </div>
                <div className="row" style={{ marginTop: '20px' }}>
                    {
                        apiData && apiData?.length > 0 ?
                            apiData?.map((value, index) => {
                                return (
                                    <div className="col-sm-4 col-xs-12" key={index}  onClick={()=>handleViewDoc(value)}>
                                        <div className="customUploadInputNew" style={{ margin: '15px 0', borderRadius: '10px',cursor:'pointer'}}>
                                            <input type="file" className='customUploadInputTag' disabled={true} style={{ pointerEvents: 'none' }}/>
                                            <div className="text" style={{ padding: '20px 10px 10px 10px' }} >
                                                <i class="fa fa-cloud-upload" aria-hidden="true" style={{ fontSize: '30px', color: '#1B6BFE' }}></i>
                                                <h5>View {value?.documentName} </h5>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            : ''}

                    {/* <div className="col-xs-12">
                        <div className='Document buttons' style={{ margin: '30px 0', display: 'flex', justifyContent: 'center' }}>

                            <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => handlPreview('Current Uploaded Document')}>View Uploaded Document</button>

                        </div>
                    </div> */}
                </div>


                {
                    documentPopup ?
                        <div className="background-blur-external">
                            <div className="popup-contact-us text-center" style={{ width: "60%", marginTop: '8%' }}>

                                <a className="text-center" style={{ fontSize: '20px' }} href={ViewDocument?.documentUrl} target='_blank'><b>{ViewDocument?.documentName}</b></a>
                                <div style={{ width: '100%', height: '80%', marginTop: '15px' }}>

                                    <iframe src={ViewDocument?.documentUrl} width={"100%"} height={"100%"}></iframe>
                                </div>

                                <div className='Document buttons' style={{ margin: '30px 0', display: 'flex', justifyContent: 'center' }}>
                                    <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => handlclose()}>Close</button>
                                </div>

                            </div>
                        </div>
                        : ''}
            </div>
        </>
    )
}
